/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');


window.Vue = require('vue');


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// https://baianat.github.io/vee-validate/guide/getting-started.html#installation
import sr_Latin from 'vee-validate/dist/locale/sr_Latin';
import VeeValidate, {Validator} from 'vee-validate';

// import into project
import Vue from 'vue';
import VuejsDialog from 'vuejs-dialog';
import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'; // only needed in custom components
 
// include the default style
import 'vuejs-dialog/dist/vuejs-dialog.min.css';

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

Validator.localize({sr_Latin: sr_Latin});

const VeeValidateconfig = {
    locale: 'sr_Latin',
    classes: true,
    classNames: {
        valid: 'is-valid',
        invalid: 'is-invalid',
    },

};
Vue.use(VeeValidate, VeeValidateconfig);


import {VueReCaptcha} from 'vue-recaptcha-v3'

Vue.use(VueReCaptcha, {siteKey: '6LdPQJ4UAAAAAEIX0Es7SEUeXm8bVKxj8RDhEKSy'});



// Vue.component('cart-component', require('./components/CartComponent.vue'));
// Vue.component('cart-row', require('./components/CartRowComponent.vue'));
// Vue.component('head-cart', require('./components/HeaderCartComponent.vue'));
Vue.component('product-card-component', require('./components/ProductCardComponent.vue'));
Vue.component('contact-form-component', require('./components/contactFormComponent.vue'));
Vue.component('search-load-more-component', require('./components/searchLoadMoreComponent.vue'));
Vue.component('cookie-policy-component', require('./components/CookiePolicyComponent.vue'));


import {EventBus} from './event-bus.js';


const app = new Vue({
    el: '#app',

    data: {
        cart_list: '',
        chartDropdownCount: 0,
        footerNewsletterEmil: '',
        isFooterNewsletterSendClicked: false,
        isFooterNewsletterSendSend: false,
        isNewsletterEmailUnique: true,
        singleProductQuantity: 1,
        cartData: {
            product_list: [],
            product_count: 0,
            total: 0
        },
        isLoading: false,
        timeCounter: 0,
        chooseUsage: null,
        chooseCoffeeNum: null,
        chooseMilk: null,
        chooseSection: 1,
        chooseSectionError: false,
        chosenMachines: [],

    },

    created() {
        // EventBus.$emit('cartDataEvent', this.cartData);
        // EventBus.$emit('cartDataEvent', payload => {
        //     this.cartData = payload;
        // });
        EventBus.$emit('cartDataEvent', this.cartData);
        // EventBus.$on('cartDataEvent', payload => {
        //
        //     this.cartData = payload;
        //
        // });
    },
    mounted() {
        const vm = this;

        this.chosenMachines = [];

        EventBus.$on('removedItemFromCArt', data => {
            // this.handleRemoveFromCart(id);
            this.cartData = data;
            this.chartDropdownCount = vm.cartData.product_count;
        });

        // axios.get(APP_URL + '/api/cart')
        //     .then(response => {
        //         vm.cartData = response.data;

        //         EventBus.$emit('cartDataEvent', response.data);
        //         // console.trace("from axios", vm.cartData);
        //         this.chartDropdownCount = vm.cartData.product_count;

        //         // console.log("this.cart_list: ",this.cart_list);
        //     }).catch(error => {
        //     console.log(error);
        // });


    },
    methods: {


        handleChooseSection(id) {
            console.log("form handleChooseSection()");
            if (id === 1) {
                const vm = this;
                if (this.chooseUsage === null) {
                    vm.chooseSectionError = true;
                } else {
                    vm.chooseSectionError = false;
                    vm.chooseSection = 1
                }

            }
            if (id === 2) {
                const vm = this;
                console.log("chooseUsage: ", this.chooseUsage);
                if (this.chooseUsage === null) {
                    vm.chooseSectionError = true;
                } else {
                    vm.chooseSectionError = false;
                    vm.chooseSection = 2
                }
            }
            if (id === 3) {
                const vm = this;
                console.log("chooseCoffeeNum: ", this.chooseCoffeeNum);
                if (this.chooseCoffeeNum === null) {
                    vm.chooseSectionError = true;
                } else {
                    this.chooseSectionError = false;
                    this.chooseSection = 3
                }
            }

        },
        handleSubmitChoose() {

            const vm = this;
            vm.isLoading = true;
            // setInterval(function(){vm.timeCounter++ }, 100);
            // console.log(vm.timeCounter);
            const postData = {
                usage: this.chooseUsage,
                coffee_num: this.chooseCoffeeNum,
                milk: this.chooseMilk
            };
            axios.post(APP_URL + '/api/choose-form', postData)
                .then(function (response) {
                    vm.chosenMachines = response.data;

                    setTimeout(function () {
                        vm.isLoading = false;
                    }, 1000);


                })
                .catch(function (error) {
                    console.log(error);
                    vm.isLoading = false;
                });


        },
        chooseCoffeeMachine() {
            console.log("From chooseCoffeeMachine()");

            const vm = this;
            if (this.chooseMilk === null) {
                vm.chooseSectionError = true;
            } else {
                vm.handleSubmitChoose();
                vm.chooseSectionError = false;
                vm.chooseSection = 4
            }
        },
        resetChooseCoffeeMachine() {
            this.chooseUsage = null;
            this.chooseCoffeeNum = null;
            this.chooseMilk = null;
            this.chooseSection = 1
        },
        increaseQuantity() {
            this.singleProductQuantity++;
        },
        decreaseQuantity() {
            if (this.singleProductQuantity > 1) {
                this.singleProductQuantity--
            } else {
                this.singleProductQuantity = 1
            }

        },
        handleOpenHeaderCart() {
            EventBus.$emit('cartDataEvent', this.cartData);
        },

        handleAddToCart(id, quantity = 1) {
            const vm = this;
            axios.post(APP_URL + '/api/cart', {
                id: id,
                amount: quantity
            })
                .then(function (response) {
                    vm.cartData = response.data;
                    EventBus.$emit('cartDataEvent', vm.cartData);
                    vm.chartDropdownCount = vm.cartData.product_list.length;

                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        handleRemoveFromCart(id) {
            // const vm = this;
            // for (var i = 0; i < this.cartData.product_list.length; i++) {
            //     if (this.cartData.product_list[i].id == id) {
            //         this.cartData.product_list.splice(i, 1);
            //         const vm = this;
            //         axios.delete(APP_URL + '/api/cart/'+id, {
            //             id: id,
            //         })
            //             .then(function (response) {
            //                 vm.cartData = response.data;
            //                 EventBus.$emit('cartDataEvent', vm.cartData);
            //                 this.chartDropdownCount = vm.cartData.product_list.length;
            //
            //             })
            //             .catch(function (error) {
            //                 console.log(error);
            //             });
            //         break;
            //     }
            // }
            // this.chartDropdownCount = this.cartData.product_list.length;
            // EventBus.$emit('cartDataEvent', this.cartData);
        },
        handleFooterNewsletterSend() {
            const self = this;
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.isFooterNewsletterSendClicked = true;
                    const postData = {
                        email: this.footerNewsletterEmil
                    };
                    axios.post(APP_URL + '/newsletter', postData)
                        .then(response => {
                            if (response.status === 201) {
                                // Pimljen mail sve OK
                                this.isFooterNewsletterSendSend = true;
                            }
                        }).catch(error => {
                        if (error.response.status === 422) {
                            this.isNewsletterEmailUnique = false;
                        }
                    });
                    return;
                }
            });
        }
    },

});




// WEBPACK FOOTER //
// ./resources/assets/js/app_noshop.js